<div class="layout-footer">
    <div>
        <span><a href="https://www.ostobuddy.com/terms/" target="_blank">Terms of Service</a></span>
        <span><a href="https://www.ostobuddy.com/privacy/" target="_blank">Privacy Policy</a></span>
    </div>
    <div>
        Copyright © {{year}} OstoBuddy
    </div>
</div>